// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.amenities.RentalManagerUserPropertyAmenityV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyAmenityCreateResponseV2WebDto,
  UserPropertyAmenityCreateV2RequestDto,
  UserPropertyAmenityDeleteV2RequestDto,
} from '../..';

export const RentalManagerUserPropertyAmenityV2WebApiHandler_create_Path =
  '/api/web/v2/users/properties/amenities/create';

/**
 * Create a free text property amenity
 */
export const RentalManagerUserPropertyAmenityV2WebApiHandler_create = (
  postData: UserPropertyAmenityCreateV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyAmenityCreateV2RequestDto, UserPropertyAmenityCreateResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyAmenityV2WebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyAmenityV2WebApiHandler_delete_Path =
  '/api/web/v2/users/properties/amenities/delete';

/**
 * Delete a free text property amenity
 */
export const RentalManagerUserPropertyAmenityV2WebApiHandler_delete = (
  postData: UserPropertyAmenityDeleteV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyAmenityDeleteV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyAmenityV2WebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
